"use strict";

module.exports = function () {
	var $body = $('body');

	$body.on('click', '[js-print]', function (event) {
		event.preventDefault();
		print();
	});

	$body.on('click', '[js-excel]', function (event) {
		event.preventDefault();

		var apiUrl = $('[handlebars-template-container]').data('apiUrl').replace(/\/report\//, '/excel/');

		window.location = apiUrl + window.location.search;
	});
};